import React from "react";
import '../App.css';
import { useWeather } from "../contextprovider/weather";

const WeatherCard = () => {
  const myweather = useWeather();

  if (!myweather || !myweather.data) return null;

  const condition = myweather.data.current?.condition?.text?.toLowerCase() || "";
  const backgroundClass =
    condition.includes("cloud") ? "cloudy" :
    condition.includes("rain") ? "rainy" :
    condition.includes("sun") ? "sunny" :
    "default";

  return (
    <div className={`card ${backgroundClass}`}>
      <img src={myweather.data.current.condition.icon} alt="Weather Icon" />
      <h3>{myweather.data.current.temp_c}°C</h3>
      <h4>{myweather.data.location.name}, {myweather.data.location.country}</h4>
      <p className="description">Condition: {myweather.data.current.condition.text}</p>
    </div>
  );
};

export default WeatherCard;
